<script setup lang="ts"></script>

<template>
  <div class="cardVideoSkeleton">
    <div class="cardVideoSkeleton__image skeletonLoading" />
    <div class="cardVideoSkeleton__content skeletonLoading" />
  </div>
</template>

<style lang="scss">
.cardVideoSkeleton {
  @apply flex max-w-full py-2 px-4 items-center w-full
  overflow-hidden cursor-wait
  transition duration-100;
  background-color: var(--base-card-bgColor);
  border-radius: var(--base-border-radius);
  .cardVideoSkeleton__image {
    @apply h-20 w-[8.5rem];
    border-radius: var(--base-border-radius);
  }
  .cardVideoSkeleton__content {
    @apply w-[12rem] h-[3rem] mx-[1rem];
  }
}
</style>
